export default "__VITE_ASSET__BcuOjRyT__"